import React, { useState } from "react";
import { FilterSearchIcon, HidePassword, ShowPassword, XIcon } from "../../../assets/images/svg";

export function Input({
  value,
  onChange,
  label,
  customProps = {},
  leftIcon,
  disabled,
  className = "",
  renderRightIcon,
  inputType = "text",
  htmlFor,
  autoComplete = "off",
  placeholder = "",
  onKeyDown
}) {
  const inputClassName = "input__field" + (className ? " " + className : "");
  const id = label ? { id: htmlFor } : {};
  return (
    <div className="input">
      {label && (
        <label className="input__label" htmlFor={htmlFor}>
          {label}
        </label>
      )}

      <div className="input__control">
        <input
          disabled={disabled}
          {...id}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          type={inputType}
          placeholder={placeholder}
          {...customProps}
          className={inputClassName}
          autoComplete={autoComplete}
          onKeyDown={onKeyDown}
        />

        {leftIcon && (
          <div className="input__icon input__icon--left" data-testid="icon-left">
            {leftIcon}
          </div>
        )}

        {renderRightIcon && renderRightIcon()}
      </div>
    </div>
  );
}

export const SearchInput = (props) => (
  <Input
    {...props}
    className="input__field--search"
    leftIcon={<FilterSearchIcon />}
    renderRightIcon={() =>
      props.value && (
        <div
          className="input__icon input__icon--right"
          data-testid="icon-right"
          onClick={props.onClear}
        >
          <XIcon />
        </div>
      )
    }
  />
);

export const PasswordInput = (props) => {
  const [passwordVisibility, setPasswordVisibility] = useState(false);

  return (
    <Input
      {...props}
      inputType={passwordVisibility ? "text" : "password"}
      renderRightIcon={() => (
        <div
          className="input__icon input__icon--right"
          data-testid="icon-right"
          onClick={() => setPasswordVisibility(!passwordVisibility)}
        >
          {passwordVisibility ? <HidePassword /> : <ShowPassword />}
        </div>
      )}
    />
  );
};

export const FileInput = ({
  onChange,
  label,
  customProps = {},
  disabled,
  className = "",
  htmlFor
}) => {
  const inputClassName = "input__field" + (className ? " " + className : "");
  const id = label ? { id: htmlFor } : {};

  const handleChange = (e) => {
    const file = e.target.files?.[0];
    if (file) {
      onChange(file);
    }
  };

  return (
    <div className="input">
      {label && (
        <label className="input__label" htmlFor={htmlFor}>
          {label}
        </label>
      )}

      <div className="input__control">
        <input
          disabled={disabled}
          {...id}
          onChange={handleChange}
          type="file"
          {...customProps}
          className={inputClassName}
        />
      </div>
    </div>
  );
};
